import React from 'react';
import './Country.css'
const Country = (props) => {
    const {name,flags,capital,population}=props.country
    return (
        <div className='country'>
            <h4>Name:{name.common}</h4>
            <img src={flags.png} alt="" />
            <p>Capital:{capital}</p>
            <p>Population:{population}</p>
        </div>
    );
};

export default Country;